import React from "react";
import { useNavigate } from "react-router-dom";

const categories = [
  {
    title: "Premium Current Affairs",
    path: "/premium-current-affairs",
    img: "https://cdn-icons-png.flaticon.com/512/2991/2991148.png"
  },
  {
    title: "Premium Question Banks",
    path: "/premium-question-bank",
    img: "https://cdn-icons-png.flaticon.com/512/3135/3135755.png"
  },
  {
    title: "Premium Notes",
    path: "/premium-notes",
    img: "https://cdn-icons-png.flaticon.com/512/2921/2921222.png"
  },
  {
    title: "Premium Mock Exams",
    path: "/premium-mock",
    img: "https://cdn-icons-png.flaticon.com/512/4315/4315445.png"
  },
  {
    title: "Detailed UPSC Analysis",
    path: "/upsc-analysis",
    img: "https://cdn-icons-png.flaticon.com/512/4149/4149643.png"
  },
  {
    title: "AI Coaching",
    path: "/ai-coaching",
    img: "https://cdn-icons-png.flaticon.com/512/4712/4712109.png"
  },
  {
    title: "Premium Law Structure",
    path: "/law-structure",
    img: "https://cdn-icons-png.flaticon.com/512/3063/3063822.png"
  },
  {
    title: "Premium Law GS1",
    path: "/law-gs1",
    img: "https://cdn-icons-png.flaticon.com/512/2910/2910791.png"
  },
  {
    title: "Premium Law GS2",
    path: "/law-gs2",
    img: "https://cdn-icons-png.flaticon.com/512/2910/2910791.png"
  },
  {
    title: "Premium Law GS3",
    path: "/law-gs3",
    img: "https://cdn-icons-png.flaticon.com/512/2910/2910791.png"
  },
  {
    title: "Premium Law GS4",
    path: "/law-gs4",
    img: "https://cdn-icons-png.flaticon.com/512/2910/2910791.png"
  },
  {
    title: "Premium IPC Sections",
    path: "/ipc-sections",
    img: "https://cdn-icons-png.flaticon.com/512/1048/1048953.png"
  }
];

export default function Dashboard() {

  const navigate = useNavigate();

  return (
    <div className="container dashboard-wrapper" style={{backgroundColor:"#000000"}}>

      <h4 className="fw-bold mb-4">
        Premium Dashboard
      </h4>

      <div className="row g-4" style={{backgroundColor:"#000000"}}>

        {categories.map((cat,index)=>(
          
          <div
            key={index}
            className="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2"
          >

            <div
              className="premium-card-modern"
              onClick={()=>navigate(cat.path)}
            >

              <div className="icon-box">
                <img src={cat.img} alt={cat.title}/>
              </div>

              <p>{cat.title}</p>

            </div>

          </div>

        ))}

      </div>
    </div>
  );
}





